module.exports = __webpack_public_path__ + "img/office2.58e621a0.svg";